// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2f377d11","184":"54203a35","203":"178e0344","239":"56e474b0","434":"a581c13e","455":"c0a12df5","511":"8c4d365f","518":"902aea46","556":"bbd47bb3","597":"63ac4d6c","664":"d93ffda4","688":"8d24eb05","710":"36452bef","735":"50a2db7c","774":"af717b78","977":"3ce04a38"}[chunkId] + ".chunk.js";
};